import { useMemo } from 'react';
import { MedicineBoxOutlined, SafetyOutlined } from '@ant-design/icons';

export const usePrescriptionRender = () => {
  return useMemo(() => {
    return (requiresPrescription: number | boolean) => {
      const isRequired = requiresPrescription === 1 || requiresPrescription === true;
      
      if (isRequired) {
        return {
          icon: <SafetyOutlined />,
          text: 'Required',
          color: '#fa8c16',
          bgColor: '#fff7e6',
          textColor: '#fa8c16',
          borderColor: '#ffd591',
        };
      }
      
      return {
        icon: <MedicineBoxOutlined />,
        text: 'Not Required',
        color: '#52c41a',
        bgColor: '#f6ffed',
        textColor: '#52c41a',
        borderColor: '#b7eb8f',
      };
    };
  }, []);
};